import { Outlet } from "react-router-dom";
import { Footer } from "../components";
import Header from "./Header";
import { NewHeader } from "./NewHeader";

export default function MainLayout() {
  return (
    <>
      <NewHeader />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}